import { isDesktop} from './exportFunc';

export default () => { 

  const section = document.querySelector('.press')

  if (!section) {
    return 
  } 

  const allItems = [...document.querySelectorAll('.press__item')]
  
  const loadMore = document.querySelector('[load-more-press]')

  const counterContent = document.querySelector('.press__filter-results-count span')

  if (!counterContent) {
    return;
  }

  counterContent.innerHTML = '0';

  const initCardPosition = (items) => {

    if (isDesktop()) {
      allItems.forEach(item => {
        const wrapper = item.querySelector('.press__wrapper');
        wrapper.style.transform = "translate3d(0, 0, 0)"
      })
  
      const itemsEven = items.filter((e, i) => (i % 2))
  
      itemsEven.forEach(item => {
        const wrapper = item.querySelector('.press__wrapper');
        wrapper.style.transform = "translate3d(0, -62px, 0)"
      })
  
      const every_nth = (arr, nth) => arr.filter((e, i) => i % nth === nth);
  
      let thirdItems = every_nth(items, 3)
  
      thirdItems = [items[2], ...thirdItems]
  
      thirdItems.forEach(item => {
        if(!item) return;
        const wrapper = item.querySelector('.press__wrapper');

        if(!wrapper) return;
        wrapper.style.transform = "translate3d(13%, 0, 0)"
      })
  
      let forthItems = every_nth(items, 4)
      forthItems = [items[3], ...forthItems]
      forthItems.forEach(item => {
  
        if (!item) {
          return 
        }
        
        const wrapper = item.querySelector('.press__wrapper');
        wrapper.style.transform = "translate3d(13%, -62px, 0)"
      })
    }

    const length = items.length;
    counterContent.innerHTML = length;
  }

  initCardPosition(allItems)

  const filterBtn = [...document.querySelectorAll('.activities-hero__filter-btn')]

  filterBtn.forEach(btn => {
    btn.addEventListener('click', () => {
      const data = btn.dataset.filter;
      const items = [...document.querySelectorAll(data === '*' ? '.press__item' : data)]

      initCardPosition(items)
    })
  })

  loadMore.addEventListener('click', () => {
    const activeBtn = document.querySelector('.activities-hero__filter-btn--active');
    const data = activeBtn.dataset.filter
    const items = [...document.querySelectorAll(data === '*' ? '.press__item' : data)]
    initCardPosition(items)
  })
}